import { SUBTYPE_OPTIONS } from '@cms/utils/constants';
import { ISystemTemplate } from '@dl/declarations';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { initialValues, schema, TemplateFormData } from '../../utils/forms/template';
import { TemplatesPath } from '../../utils/routes';
import { ControlledDropdown } from '../data/Dropdown';
import { ControlledSystemTextInput } from '../data/TextInput';
import { TemplateEditor } from '../editor/Editor';
import { EditorWrapper } from '../editor/EditorWrapper';
import ReadyNodes from '../editor/nodes/ReadyNodes';
import { GeneralSettingsComponent } from '../editor/shared/GeneralSettings';
import { contentElementsToLexical } from '../editor/utils/helpers';
import { FormContainer } from './FormContainer';


export const Form = () => {
    return (
        <div className='bg-cs-200 w-full flex flex-col items-start gap-2'>
            <div className='w-full grid grid-cols-12 items-center p-2 gap-2'>
                <div className='col-span-4'>
                    <ControlledSystemTextInput
                        description='Template Name'
                        placeholder='Add template name'
                        name='info.name'
                    />
                </div>

                <div className='col-span-6'>
                    <ControlledSystemTextInput
                        description='Template Description'
                        placeholder='Add template description'
                        name='info.description'
                    />
                </div>

                <div className='col-span-2'>
                    <ControlledDropdown
                        description='Subtype'
                        name='subtype'
                        options={SUBTYPE_OPTIONS}
                        label='Content type'
                        valueKey='_id'
                        inputSize='full'
                        searchOptions={{
                            allow: false
                        }}
                    />
                </div>
            </div>

            <hr className='w-full text-cs-300' />

            <GeneralSettingsComponent
                rightColumnOptions={{
                    show: false
                }}
            />

            <TemplateEditor />
        </div>
    )
}

const TemplateFormContent = () => {
    const [editor] = useLexicalComposerContext();

    return (
        <FormContainer<TemplateFormData>
            title='Template'
            headerOptions={{
                show: false
            }}
            actionsOptions={{
                show: true,
                position: 'top'
            }}
            formSize='full'
            queryOptions={{
                enabled: true,
                basePath: TemplatesPath,
                transformData(data: ISystemTemplate) {
                    contentElementsToLexical(editor, data.content_elements || []);
                    return data
                },
            }}
            schema={schema}
            defaultValues={initialValues}
            deleteOptions={{
                show: true
            }}
        >
            <Form />
        </FormContainer>
    )
}

export const TemplateForm = () => {
    return (
        <EditorWrapper
            initialConfig={{
                editorState: undefined,
                namespace: "TemplateEditor",
                onError: (error: Error) => {
                    console.error(error);
                },
                nodes: [...ReadyNodes]
            }}
        >
            <TemplateFormContent />
        </EditorWrapper>
    )
}